import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {RemarkListAPI, CallerAPI} from "./../../API/Team/RemarkAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";


const Remarks = () =>{

    const [remarks, setRemarks] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [filteremail, setFilterEmail] = useState("");
    const [filtercallerid, setFilterCallerId] = useState("");
    const [callers, setCallers] = useState([]);
    
    const perpagedata = 20;


    useEffect(() => {

        CallerAPI(setCallers);
        RemarkListAPI(setRemarks, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleSelectCaller =(e) =>{

        setFilterCallerId(e.target.value);
    }

    const handleInputEmailFilter = (e) =>{
        setFilterEmail(e.target.value);
    }

    const handleFilterRemarks = () =>{
    
            console.log('Filter Lead ID====' + filtercallerid);
            console.log('Filter Email====' + filteremail);
    
            const filterparams = new URLSearchParams();
    
            if(filtercallerid)
            {
                filterparams.append('filtercallerid', filtercallerid);
            }
    
            if(filteremail)
            {
                filterparams.append('filteremail', filteremail);
            }
    
            if(currentPage)
            {
                filterparams.append('page', currentPage);
            }
    
            if(perpagedata)
            {
                filterparams.append('per_page', perpagedata);
            }
    
            RemarkListAPI(setRemarks, setLoading, currentPage, perpagedata, setPageCount, filterparams);
        }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="d-flex align-items-center flex-wrap kanban-filter">
                                <div className="email-filter me-2">
                                    <select className="form-select" name="caller" value={filtercallerid} onChange={handleSelectCaller}>
                                        <option value="">Select Caller</option>
                                        {callers.map((caller) =>
                                            (
                                                <option key={caller.id} value={caller.id}>{caller.name}</option>
                                                
                                            ))                                        
                                        }
                                    </select>
                                </div>
                                <div className="email-filter me-2">
                                    <input className="form-control" type="email" name="filteremail" onChange={handleInputEmailFilter} placeholder="Filter by Email" />
                                </div>

                                
                                <div className="button-filter me-2">
                                    <button type="button" className="btn btn-primary" onClick={handleFilterRemarks}>
                                        <i className="ti ti-search me-2"></i>Apply Filter
                                    </button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Remarks</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <div className="table-responsive custom-table">
                                    <table className="table table-hover" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Lead Name</th>
                                                <th scope="col">Email</th>
                                                <th scope="col">Remarks</th>
                                                <th scope="col">Remark Date</th>
                                                <th scope="col">Caller Name</th>
                                                {/*<th className="text-end">Action</th>*/}
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="5">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (remarks && remarks.length > 0  ? 
                                                ( remarks.map(remark => 
                                                    (
                                            
                                                        <tr key={remark.id}>
                                                            <td>{remark.name}

                                                            </td>
                                                            <td>{remark.email}</td>
                                                            <td>{remark.remarks}</td>
                                                            <td>
                                                                {remark.created_at !== "" && remark.created_at !== null ? 
                                                                    (moment(remark.created_at).format('DD MMMM, YYYY'))
                                                                :
                                                                    <>-</>
                                                                }
                                                            </td>
                                                            <td>
                                                            {remark.username ?
                                                                remark.username
                                                            :
                                                                <></>
                                                            }

                                                            </td>
                                                            {/*<td className="text-end">
                                                                <Link to="" class="btn btn-dark btn-sm">
                                                                    <i className="ti ti-pencil"></i> Edit
                                                                </Link>
                                                                <button type="button" class="btn btn-danger btn-sm">
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>													
                                                            </td>*/}
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="5">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }
                    </div>
                </div>

            </div>
        </div>

    </div>
    )
}

export default Remarks;